<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 작성기간 -->
          <c-datepicker
            type="month"
            :range="true"
            defaultStart="-3M"
            defaultEnd="1M"
            label="작성기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            codeGroupCd="ENV_SAF_KPI_STATUS_CD"
            itemText="codeName"
            itemValue="code"
            name="envSafStatusCd"
            label="진행상태"
            v-model="searchParam.envSafStatusCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 환경, 안전보건 KPI 목록 -->
    <c-table
      ref="table"
      title="환경, 안전보건 KPI 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--등록-->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" />
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import selectConfig from '@/js/selectConfig';
export default {
  name: 'env-saf-kpi',
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        envSafStatusCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            //사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'targetMonth',
            field: 'targetMonth',
            label: '작성월',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'targetTitle',
            field: 'targetTitle',
            label: '제목',
            align: 'left',
            style: 'width:350px',
            sortable: true,
            type: 'link'
          },
          {
            name: 'envSafStatusName',
            field: 'envSafStatusName',
            label: '진행상태',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            // 결재진행단계
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: 'LBL0000212',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'writeDeptName',
            field: 'writeDeptName',
            //작성부서
            label: 'LBLWRITEDEPT',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            //작성일
            label: 'LBLREGDATE',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.esk.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = '환경, 안전보건 KPI 상세';  //환경, 안전보건 KPI 상세
      this.popupOptions.param = {
        sopEnvSafKpiId: row ? row.sopEnvSafKpiId : '',
      };
      this.popupOptions.target = () => import(`${'./envSafKpiDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
